import { Checkbox, Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { AggregateSizeFraction } from '../../types';

let BsEnResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const showLosAngelesValue_31_5 = useSelector(
    pipe(
      createWorksheetSelector!('Preparation'),
      (d) => d.UseAdditionalSieve!! && d.AggregateSizeFraction === AggregateSizeFraction.Sizes31_5mmTo50mm
    )
  );

  return (
    <>
      <NamePrefixModifier appendNamePrefix="Results">
        <ListFieldSection>
          <Field input={<TextOutput />} name="LosAngelesValue" />
          {showLosAngelesValue_31_5 && <Field input={<TextOutput />} name="LosAngelesValue_31_5" />}
        </ListFieldSection>

        <ListFieldSection single heading="Report">
          <Field input={<Checkbox />} name="ReportSamplingProcedure" />
          <Field input={<Checkbox />} name="ReportSampleReductionProcedure" />
          <Field input={<Checkbox />} name="ReportTestPortionMass" />
          <Field input={<Checkbox />} name="ReportAggregateSizeFraction" />
          <Field input={<Checkbox />} name="ReportSampleReceivedDate" />
        </ListFieldSection>
      </NamePrefixModifier>
      <WorksheetsResultsMessagesSection />
    </>
  );
};

BsEnResultsSection = withInjectedProps(BsEnResultsSection);

export { BsEnResultsSection };
export default BsEnResultsSection;
